import React, { FC } from 'react'
import ProfileMenuHeader from '../ProfileMenuHeader'
import { Menu } from '../ProfileMenu'

type Props = {
  onClose: any
}

const PrivacyPolicy: FC<Props> = ({ onClose }) => {
  const handleClose = () => {
    onClose(Menu.PROFILE)
  }
  return (
    <div>
      <ProfileMenuHeader
        text="Privacy & Policy"
        onClose={handleClose}
      />
    </div>
  )
}

export default PrivacyPolicy